<div class="container-fluid wallet-container bg-white shadow-sm rounded p-3 p-md-4">
    <div class="wallet-header d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between mb-4">
        <div class="mb-4">
            <div class="d-flex justify-content-start align-items-center" (click)="dialogRef.close()">
                <mat-icon fontIcon="arrow_back" class="back-icon"></mat-icon><span>Back</span>
            </div>
            <h2 class="mt-4 main-text">Change Wallet</h2>
            <p class="text-muted small">Select from your wallet or add a new one</p>
        </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-4">
        <h5 class="wallet-list-header">Your Wallet</h5>
        <button
            class="main-btn d-flex justify-content-between align-items-center"
            mat-raised-button
            (click)="switchToAddNewWallet()"
            [class.btn-primary-disabled]="wallets.length >= 13"
            [disabled]="wallets.length >= 13"
        >
            <mat-icon>add</mat-icon>Add new wallet
        </button>
    </div>
    <div class="wallet-list mt-3">
        <div
            *ngFor="let wallet of wallets"
            class="wallet-item d-flex align-items-center justify-content-between m-3 pb-2"
            (click)="changeSelectedWallet(wallet)"
            [ngClass]="{ selected: wallet.selected }"
        >
            <div class="wallet-info d-flex align-items-center justify-content-start">
                <mat-icon *ngIf="wallet.selected" class="text-success me-2">check</mat-icon>
                <img [src]="'../../../../../assets/currency-flags/' + wallet.currency + '-flag.svg'" [alt]="wallet.currency" class="flag-icon me-3" />
                <div>
                    <p class="mb-0 font-weight-bold">{{ wallet.currency }} Wallet</p>
                    <small class="text-muted">{{ wallet.currency }}</small>
                </div>
            </div>

            <div class="wallet-balance text-right">
                <p class="mb-0 font-weight-bold">{{ wallet.balance | currency : wallet.currency : '' }}</p>
                <small class="text-muted">Balance</small>
            </div>
        </div>
    </div>
</div>
